const form = {
  year: "Jahr",
  invoiceStatus: "Rechnungsstatus",
  firstName: "Vorname",
  lastName: "Nachname",
  email: "Email",
  phone: "Telefon",
  address: "Anschrift",
  status: "Status",
  password: "Password",
  confirmPassword: "Confirm Password",
  dateOfEntry: "Datum Eintritt",
  dateOfExit: "Datum Austritt",
  city: "Stadt",
  voucherType: "Gutscheinart",
  sortBy: "Sort by",
  salutation: "Anrede",
  measures: "Maßnahme",
  intermediary: "Vermittler (Internal)",
  lecturer: "Dozent",
  preview: "Vorschau",
  loading: "Loading.....",
  invalidLink: "Ungültiger Link",
  invalidLinkMessage: "Der Link, den Sie klicken, ist ungültig oder abgelaufen.",
  pleaseFillAllTheFields: "Bitte füllen Sie alle Felder aus",
  pleaseSignTheForm: "Bitte signieren Sie das Formular",
  // Authority
  authority: "Behörde",
  bgNumber: "BG-Nummer",
  team: "Team",
  contactPerson: "Ansprechpartner",
  routingId: "Leitweg-ID (für E-Rechnung)",
  invoice: "Rechnung",
  contactEmail: "Ansprechpartner E-mail",
  contactTel: "Ansprechpartner Tel",
  authorityStreet: "Behörde Straße und Hausnummer",
  authorityPostalCode: "Behörde PLZ",
  authorityCity: "Behörde Stadt",
  measure: "Maßnahme",
  intermediary: "Vermittler (Internal)",
  reports: "Reports",

  required: "Dieses Feld ist erforderlich",
  invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
  error: "Fehler",
  success: "Erfolg",

  settings: "Einstellungen",
  permissionToSignRetroactively: "Erlauben um rückwirkend zu unterschreiben",
  receiveTeachingMaterials: "Lehrmittel erhalten",
  faceToFaceInstruction: "Präsenzunterricht",
  onlineInstruction: "Onlineunterricht",
  informationForSuccessAndPlacementStatistics: "Angaben für Erfolgs- und Vermittlungsstatistik",
  surveyedAfter6Months: "nach 6 Monaten befragt",
  mediated: "vermittelt",
  saveDetails: "Details speichern",

  street: "Straße",
  streetName: "Straßenname",
  streetNo: "Hausnummer",
  country: "Land",
  pincode: "Postleitzahl",
  userId: "Benutzer-ID",

  examinations: "Prüfungen",
  reportsToTheInsuranceProvider: "Meldungen an den Kostenträger",
  feedbackForm: "Feedbackbogen",
  theParticipantHasNotYetAnsweredAnyFeedbackQuestions: "Der Teilnehmer hat noch keine Feedbackfragen beantwortet!",
  createADischargeReport: "Austrittsmeldung erstellen",
  dischargeReport: "Austrittsmeldung",
  createATerminationReport: "Abbruchsmeldung erstellen",
  terminationReport: "Abbruchsmeldung",
  generatedMessages: "Generierte Meldungen",
  date: "Datum",
  description: "Beschreibung",
  sentTo: "Gesendet an",
  sentOn: "Gesendet am",
  edit: "Bearbeiten",
  examsFrom: "Prüfung von",
  examsTo: "Prüfung bis",
  examType: "Prüfungart",
  registerForExam: "Zur Prüfung eintragen",
  differentInvoiceRecipient: "Abweichender Rechnungsempfänger",
  ifYouWouldLikeToEnterADifferentInvoiceRecipient: 'Wenn Sie einen abweichenden Rechnungsempfänger eintragen möchten, füllen Sie bitte die folgenden Felder aus. Bei der Erstellung der Rechnung oder Mahnung werden die Eingaben in den Feldern "Abweichender Rechnungsempfänger" die Felder des "Kostenträgers" überschreiben.',
  bahrodeCompany: "Behörde / Firma",
  contactPerson: "Ansprechpartner",
  routingId: "Leitweg-ID (für E-Rechnung)",
  billingEmail: "Rechnung E-mail Adresse",
  streetAndHouseNumber: "Straße und Hausnummer",
  postalCode: "PLZ",
  registeredExamDates: "Eingetragene Prüfungstermine",
  examinationFromTo: "Prüfung von - bis",
  typeOfExam: "Prüfungsart",
  examinationResult: "Prüfungsergebnis",
  certificate: "Zertifikat",
  billedOn: "Abgerechnet am",

  houseNumber: "Hausnummer",
  placeOfBirth: "Geburtsort",
  phoneNumber: "Telefon",
  countryOfbirth: "Geburtsland",
  email: "E-mail",
  birthDate: "Geburtsdatum",
  remarks: "Bemerkungen",

  createAttendanceList: "Anwesenheitsliste erstellen",
  dateFrom: "Datum Von",
  dateUntil: "Datum Bis",
  createACertificateOfAbsenceForTheJobCenter: "Bescheinigung der Fehlzeiten für das JobCenter erstellen",
  createPDF: "PDF erstellen",
  missingSignatures: "Fehlende Unterschriften",
  allSignaturesAreThere: "Alle Unterschriften sind da!",
  updatedOn: "Aktualisiert am",
  updateAttendance: "Anwesenheit aktualisieren",
  missingSignaturesForDays: "Es fehlen Unterschriften für {{count}} Tag(e):",
  markDateAsPresent: "Wollen Sie das Datum {{date}} als anwesend markieren?",
  yesMarkPresent: "Ja, als anwesend markieren",
  reasonsForAbsence: "Fehltagbegründungen",
  certificateFor: "Bescheinigung für",
  dayOfAbsenceFrom: "Fehltag von",
  dayOfAbsenceUntil: "Fehltag bis",
  reason: "Grund",
  noEntriesFound: "Keine Einträge gefunden",
  aMaximumOfFourReasonsForAbsenceCanBeEnteredOnBehalfOfTheParticipantInTheSGBFbWCertificateOfAbsenceDocument: 'Es können maximal 4 Fehltagbegründungen im Namen des Teilnehmers in das Dokument "SGB III - FbW Bescheinigung der Fehlzeiten" in das Feld "Vom Teilnehmenden auszufüllen:" -> "Stellungnahme zu den Fehltagen:" übernommen werden!',
  justifyAbsence: "Fehltag begründen",
  certificatesOfAbsenceIssued: "Erstellte Bescheinigungen der Fehlzeiten",
  fileToDownload: "Datei zum Herunterladen",
  edit: "Bearbeiten",
  createdAttendancePDFs: "Erstellte Anwesenheits PDFs",
  presenceOf: "Anwesenheit von",
  presenceUntil: "Anwesenheit bis",

  insertSickNoteOrDayOfAbsence: "Krankschreibung oder Fehltag einfügen",
  reasonForSickLeaveOrAbsence: "Krankschreibung oder Fehltag begründen",
  reasonsForSickLeaveOrDaysOfAbsenceAreTransferredToTheDocument: 'Begründungen für Krankschreibung oder Fehltage werden in das Dokumen "SGB III - FbW Bescheinigung der Fehlzeiten" in das Feld "Fehlzeiten" -> "Begründung" übernommen!',

  createEInvoices: "E-Rechnungen erstellen",
  invoiceNumber: "Rechnungsnummer",
  invoiceDate: "Rechnungsdatum",
  invoiceAmountInEUR: "Rechnungssumme in EUR",
  invoiceType: "Rechnungsart",
  createInvoices: "E-Rechnungen erstellen",
  rgNumber: "Rg-Nummer",
  rgDate: "Rg-Datum",
  rgSum: "Rg-Summe",
  reminder: "Mahnung",
  reminderAutodispatch: "Mahnung-Autoversand",
  paid: "Bezahlt",
  recordID: "Record ID",
  paidOn: "Bezahlt am",
  unpaid: "Unbezahlt",
  messages: "Nachrichten",
  mr: "Herr",
  mrs: "Frau",
  drivers: "Fahrer",

  eExcused: "E - Entschuldigt",
  ueUnexcused: "UE - Unentschuldigt",
  kIllness: "K - Krank",
  sOther: "S - Andere",
  plz: "PLZ",
  dateOfDeparture: "Datum der Abreise",

  motherTongue: "Muttersprache",
  verhandlungssicher: "Verhandlungssicher",
  veryGood: "Sehr gut",
  good: "Gut",

  shiftSystem: "Schichtsystem (Tag/Nacht/Wochenende)",
  workingHours: "Vollzeit",
  healthRestrictions: "gesundheitliche Einschränkungen",
  furniture: "Mobilität (Öffentliche/Auto)",
  miscellaneous: "Sonstiges",
  yes: "Ja",
  no: "Nein",

  internetEnabledHardware: "Internetfähiges (mit einer Bandbreite von mindestens 1,5 Mbit/s ist empfohlen) Handy, Tablet, Laptop, PC o.ä. (Hardware) vorhanden?",
  b1LevelIsAvailable: "B1 Niveau ist vorhanden",
  jobBoardAccessDataAvailable: "Zugangsdaten Jobbörse vorhanden",
  certificateOfGoodConductWasAvailable: "Führungszeugnis lag vor",
  experienceInTheSecuritySector: "Erfahrungen im Sicherheitsbereich",
  lastEmploymentRelationship: "Letztes Arbeitsverhältnis",
  currentEmploymentRelationship: "Aktuelles Arbeitsverhältnis",

  assessmentOfSuitabilityForFurtherTraining: "Eignungsfeststellung für die Weiterbildung",
  chamberOfIndustryAndCommerceCertifiedSafetySpecialist: '„IHK geprüfte Sicherheitsfachkraft gemäß §34a GewO Online“',
  houseRules: "Hausordnung",
  readCarefully: "(Sorgfältig lesen)",
  order: "Ordnung",
  allRoomsAndFacilitiesAtOurSchoolMustBeMaintainedInOrderAndCleanliness: "In sämtlichen Räumen und Anlagen unserer Schule ist auf Ordnung und Sauberkeit zu achten. Schulräume, Einrichtungen und Anlagen sind sorgfältig zu benutzen. Außerhalb der Unterrichtszeiten dürfen sich Lernende nicht in den Klassenräumen aufhalten. Es ist untersagt, in den Klassenräumen etwas an die Wände zu kleben oder zu schreiben und Schulmöbel in andere Räume zu bringen. Mitarbeitende und Lernende, die Schäden feststellen, melden diese dem Sekretariat.",
  alcoholAndDrugConsumption: "Alkohol- und Drogenkonsum",
  theConsumptionOfAlcohol: "Der Konsum von Alkohol, illegalen Drogen sowie anderen psychoaktiven Substanzen ist auf dem gesamten Schulareal und während schulischer Veranstaltungen (einschließlich aller Pausen) verboten. In Ausnahmefällen kann die Schulleitung den Konsum von Alkohol erlauben.",
  theft: "Diebstahl",
  theftDescription: "Es empfiehlt sich, Wertsachen und Bargeld sorgfältig aufzubewahren. Die Schule stellt den Lernenden und Mitarbeitenden kostenlos Schließfächer zur Verfügung. Für verlorene Schlüssel wird eine Gebühr von Euro 50,- erhoben. Die Schule übernimmt für Diebstähle keine Haftung.",
  parking: "Parkplätze",
  thereAreNoFreeParkingSpacesAvailableOnTheSchoolGrounds: "Auf dem Schulareal stehen keine Gratis-Autoparkplätze zur Verfügung. Fahrräder müssen in den dafür vorgesehenen Fahrradkeller gebracht und abgeschlossen werden. Mopeds und Motorräder sind auf dem Schulareal nicht erlaubt.",
  taskDescription: "Lesen Sie den Text und die Aufgaben 1 bis 4 dazu. Wählen Sie bei jeder Aufgabe die richtige Lösung: a, b oder c. Sie informieren sich über die Hausordnung der BAD Bildungsakademie Deutschland GmbH. Sie nehmen in deren Räumlichkeiten an einem Lehrgang teil.",
  oneAnswerIsCorrect: "Jeweils eine Antwort ist richtig!",

  questionTask2_1: "Was sind die Reaktionen auf Frustration?",
  questionTask2_2: "Welche Anzeichen könnten auf Drogenkonsum hinweisen?",
  questionTask2_3: "Was sollte man beim Umgang mit Gruppen beachten?",
  questionTask2_4: "Was ist ein grundlegendes menschliches Bedürfnis?",
  questionTask2_5: "Welches Verhalten kann man bei betrunkenen Personen erwarten?",
  calmness: "Ruhe",
  contentment: "Zufriedenheit",
  aggression: "Aggression",
  increasedConcentration: "Erhöhte Konzentrationsfähigkeit",
  socialEngagement: "Soziales Engagement",
  dilatedPupils: "Erweiterte Pupillen, Hautverfärbungen",
  easilyProvoked: "Leicht provozierbar",
  formingAlliances: "Bildung von Allianzen mit der Gruppe",
  behavingNeutrally: "Neutrales Verhalten",
  food: "Essen",
  selfActualization: "Selbstverwirklichung",
  friendship: "Freundschaft",

  generalKnowledge: "Allgemeine Wissen",
  questionTask3_1: "Wie hoch ist der Mehrwertsteuersatz in Deutschland?",
  questionTask3_2: "Welche Berufe kann man mit der Sachkundeprüfung nach § 34a GewO ausüben?",
  questionTask3_3: "Wer ist in Deutschland für die Einhaltung des Gesetzes verantwortlich?",
  questionTask3_4: "Wie viele Bundesländer hat Deutschland?",
  questionTask3_5: "Wie heißt der aktuelle Bundeskanzler Deutschlands?",

  cleaner: "Reinigungskraft",
  securityGuard: "Sicherheitsmitarbeiter",
  busDriver: "Busfahrer",
  thePolice: "Die Polizei",
  theCourts: "Die Gerichte",
  theSecurityServices: "Die Sicherheitsdienste",
  answer5: "5",
  answer16: "16",
  answer23: "23",
  msMerkel: "Frau Merkel",
  mrAdenauer: "Herr Adenauer",
  mrScholz: "Herr Scholz",
  hamburg: "Hamburg",
  munich: "München",
  berlin: "Berlin",
  signature: "Unterschrift",
  plz: "PLZ",

  ifNoThisWillBeRequestedBeforeTheStartOfTheMeasureAndSubmitted: "Wenn Nein -> wird vor Maßnahme Beginn beantragt und der BAD Bildungsakademie Deutschland GmbH vorgelegt. Danach Kann die Maßnahme erst begonnen werden, wenn keine relevanten Einträge vorhanden sind. Dies habe ich zur Kenntnis genommen und bestätige ich.",
  applicantSignature: "Unterschrift des Bewerbers",
  yesHerebyConfirm: "ja -> hiermit wird bestätigt, dass mir durchaus bewusst ist, dass die Maßnahme in Vollzeit stattfindet. Ich traue mir zu, dies parallel zu absolvieren.",
  herebyConfirmCompleteness: "Hiermit bestätige ich die Vollständigkeit und Richtigkeit der oben genannten Angaben und erkläre mich damit einverstanden, dass die BAD Bildungsakademie Deutschland GmbH, meine persönlichen Daten bis auf Wiederruf in Ihrem System speichern darf.",

  NameOfTheClerkAndDate: "Name des Kassierers und Datum",
  certificateOfGoodConductWasAvailable: "Führungszeugnis lag vor",
  relevantEntry: "Relevant Eintrag",
  notRelevantEntry: "Nicht relevanter Eintrag",
  noEntry: "Kein Eintrag",
  certificateOfGoodConductWasNotAvailable: "Zugang zum Zertifikat der guten Verhaltensweise nicht verfügbar:",
  remarksNotesFromTheClerkDuringTheInterview: "Bemerkungen/Notizen des Kassierers während der Interview:",
  willBeSubmittedOn: "Wird am:",
  reminderSet: "Erinnerung gesetzt (Outlook, Mobil, andere)",

  allMeasures: "alle Maßnahmen",
  showEvaluation: "Auswertung anzeigen",
  createdFeedbackEvaluations: "Erstellter Feedbackbogen-Auswertungen",
  feedbackEvaluation: "Feedbackbogen-Auswertung",
  successAndPlacementStatistics: "Erfolgs- und Vermittlungsstatistik",
  createdSuccessAndPlacementStatistics: "Erstellte Erfolgs-und Vermittlungsstatistik-Auswertungen",
  qualificationPlanCreate: "Qualifizierungsplan Erstellen",
  createdQualificationPlans: "Erstellte Qualifizierungsplane",

  German: "Deutsch",
  English: "Englisch",
  French: "Französisch",
  Turkish: "Türkisch",
  Arabic: "Arabisch",
  Other: "Andere",
  interestedInMeasure: "An welcher Maßnahme ist der Teilnehmer interessiert:",
  dataCollectionForm: "Erfassungsbogen",
  basicKnowledge: "Grundkenntnisse",

  fromTime: "Zeit Von",
  toTime: "Zeit Bis",
  photo: "Foto",
  duration: "Zeit",
  hour: "Uhr",
  to: "bis",

  // Results Sheet
  carrierOfTheMeasure: "Träger der Maßnahme",
  nameOfTheMeasure: "Bezeichnung der Maßnahme",
  measureNumber: "Maßnahme-Nummer",
  contactPersonInclTel: "Ansprechpartner/in (inkl. Tel.Nr.)",
  nameFirstName: "Name, Vorname",
  placeOfResidence: "(Wohnort-) Agentur fur Arbeit / Jobcenter",
  orgNumber: "Org.zeichen / Kundennummer",
  referenceNumber: "Referenznummer Bewerberprofil",
  finalInvoice: "Schlussrechnung",
  rate: "Rate",
  expertKnowledge: "Experten-Kenntnisse",
  advancedKnowledge: "Erweiterte-Kenntnisse",
  basicKnowledge: "Grund-Kenntnisse",
  willingnessToBeMobile: "Mobilitatsbereitschaft",
  acrossTheCountry: "bundesweit",
  international: "international",
  maxPendelTime: "max. Pendelzeit (gesamt)",
  regionalWishes: "Regionale Wunsche",
  from: "Von",
  to: "Bis",
  at: "Bei",
  activity: "Tätigkeit als",
  applicationTo: "Bewerbung bei",
  participant: "Teilnehmer",
  resultOpen: "Ergebnis Offen",
  cancellation: "Absage",
  dateOfTheParticipant: "Datum (Teilnehmer)",
  trainingSupportCreated: "Erstellte Förderung der beruflichen Weiterbildung Ergebnisbogen",

  participantId: "Teilnehmer-ID",
  attendanceInTheMorning: "Anwesenheit vormittags",
  attendanceInTheAfternoon: "Anwesenheit nachmittags",

  documents: "Dokumente",
  fileDescription: "Datei - Beschreibung",
  fileUpload: "Datei zum hochladen",
  uploadedFiles: "Hochgeladene Dateien",
  certificates: "Zertifikate",
  certificateOfTheCarrier: "Tragerzertifikat generieren",
  generatedMessages: "Generierte Meldungen",
  createdFeedbackForms: "Erstellter Feedbackbogen",
  createdCertificatesOfAbsences: "Erstellte Bescheinigungen der Fehlzeiten",
  certificatesOfAbsences: "Bescheinigungen der Fehlzeiten",
  createdInvoices: "Erstellte Rechnungen",
  createdProfessionalDevelopmentFundingRequestResultsSheet: "Erstellte Förderung der beruflichen Weiterbildung Ergebnisbogen",
  trainingReportsOfTheParticipant: "Schulungsreports des Teilnehmers",
  updatedOn: "Aktualisierrt am",
  attendanceDate: "Anwesenheit Datum",
  willBeDisplayedFrom1300: "Wird ab 13:00 angezeigt",
  willBeDisplayedFrom0900: "Wird ab 09:00 angezeigt",
  weekend: "Wochenende",
  holiday: "Feiertag"
}

export default {
  common: {
    true: "Richtig",
    false: "Falsch",
    points: "Punkte",
    timeRemaining: "Verbleibende Zeit",
    remaining: "übrig",
    examTimeOver: "Prüfungzeit ist abgelaufen",
    second: "Sekunde",
    seconds: "Sekunden",
    minutes: "Minuten",
    newExam: "Neue Prüfung starten",
    continueWithOldExam: "Alte Prüfung weiter bearbeiten",
    whichExamWouldYouLikeToStart: "Welche Prüfung möchten Sie bearbeiten?",
    saveClose: "Speichern und schließen",
    endExam: "Prüfung beenden",
    halfPointsLabel: "1 von 2 Punkten",   // ← add this (example key)

    examSheetSuccessMessage: "Herzlichen Glückwunsch! Du hast die Prüfung abgeschlossen.",
    examSheetSuccessTitle: "PRÜFUNG BESTANDEN",
    examSheetSuccessDescription: "Deine Punktzahl :",
    examSheetSuccessPercentage: "Prozentsatz :",
    examSheetSuccessThankYou: "Vielen Dank für deine Teilnahme an der Prüfung.",
    examSheetNotPassed: "NICHT BESTANDEN",
    fridaySheetTitle: "Sachkunde 34a- Deine Freitagsprüfung",
    fridaySheet: "Freitagsprüfung",
    examHistory: "Prüfungshistorie",

    leaveExamTitle: "Möchten Sie die Prüfung wirklich verlassen.",
    leaveExamSubtitle: "Sie haben die Möglichkeit die Prüfung bei Ihrer letzten Frage später weiter zu bearbeiten",
    confirm: "Bestätigen",
    cancel: "Abbrechen",

    correctAnswer: "Richtige Antwort",
    learn_mode: "Übungsmodus (Learnmode)",
    exam_mode: "Prüfungsmodus",
    continue_to_exercises: "Weiter zu den Übungsaufgaben",
    continue_to_exam_sheet: "Weiter zur Prüfungssimulation",
    continue_to_exam_history: "Weiter zur Prüfungshistorie",
    somethingWentWrong: "Etwas ist schiefgelaufen, bitte versuchen Sie es später noch einmal",
    backToHome: "Zurück zur Startseite",
    commingSoon: "In Kürze verfügbar",
    pleaseAdd: "Bitte hinzufügen",
    search: "Suche",
    clearAll: "Alle löschen",
    filter: "Filter",
    applyFilter: "Filter anwenden",
    pleaseEnter: "Bitte eingeben",
    pleaseSelect: "Bitte auswählen",
    addNewUser: "Neuen Benutzer hinzufügen",
    editUser: "Benutzer bearbeiten",
    rowsPerPage: "Zeilen pro Seite",
    displaying: "Anzeigen {from} bis {to} von {total} Einträgen",
    previous: "Vorherige",
    next: "Nächste",
    all: "Alle",
    page: "Seite",
    of: "von",
    goToPage: "Gehe zu Seite",
    first: "Erste",
    last: "Letzte",
    active: "Aktiv",
    inactive: "Inaktiv",
    send: "Senden",
    updateAndRegeneratePDF: "Aktualisieren und PDF neu generieren",
    save: "Speichern",
    yes: "Ja",
    no: "Nein",
    back: "Zurück",
    update: "Aktualisieren",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    setUpPassword: "Passwort einrichten",
    newPassword: "Neues Passwort",
    confirmPassword: "Passwort bestätigen",
    saveChanges: "Änderungen speichern",
    required: "Dieses Feld ist erforderlich",
    invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    invalidPassword: "Das Passwort muss mindestens 8 Zeichen lang sein",
    confirmPasswordError: "Passwörter stimmen nicht überein",
    noDataFound: "Keine Daten gefunden",
    date: "Datum",
    ID: "ID",
    actions: "Aktionen",
    participantData: "Teilnehmerdaten",
    contactDetails: "Kontaktdaten",
    attendance: "Teilnahme",
    sickNotes: "Krankschreibungen/Abwesenheiten",
    invoices: "Rechnungen",
    resultsSheet: "Ergebnissheet",
    learningProgress: "Lernfortschritt",
    documents: "Dokumente",
    invalid: "Bitte geben Sie eine gültige Information ein",
    invalidPhoneNumber: "Ungültige Telefonnummer",
    areYouSureYouWantToProceed: "Sind Sie sicher, dass Sie fortfahren möchten?",
    confirmation: "Bestätigung",

    task: "Aufgabe",
    tasks: "Aufgaben",
    students: "Schüler...",
    theFollowingAppliesToTheClassroomsOfBADBildungsakademieDeutschlandGmbH: "Die folgenden Bedingungen gelten für die Räume der BAD Bildungsakademie Deutschland GmbH:",
    toUseTheLockableLockersYouMust: "Um das Schließfach zu nutzen, muss...",
    drinkingAlcohol: "Alkohol...",
    areNotAllowedToBringBicyclesToSchool: "Es ist nicht erlaubt, Fahrräder zur Schule zu bringen.",
    areAllowedToLeaveTheirBicyclesInTheSchoolyard: "Es ist erlaubt, ihre Fahrräder im Schulgarten zu lassen.",
    mustLeaveTheirBicyclesInASpecialRoom: "Sie müssen ihre Fahrräder in einem besonderen Raum lassen.",
    studentsAreNotPermittedToHangPosters: "Schüler dürfen keine Plakate aufhängen.",
    studentsMustCleanUpAfterClass: "Schüler müssen nach dem Unterricht aufräumen.",
    studentsMayStudyThereAfterClass: "Schüler können dort nach dem Unterricht lernen.",
    requestAKeyFromTheOffice: "Fordern Sie einen Schlüssel beim Büro an.",
    payAOneTimeFeeOf50: "Zahlen Sie eine einmalige Gebühr von €50.",
    beAStudentOrWorkAt: "Muss Schüler sein oder bei der BAD Bildungsakademie Deutschland GmbH arbeiten.",
    mayBeApprovedByTheSchoolAdministration: "Kann von der Schulverwaltung genehmigt werden.",
    mustBeReportedToTheTeacher: "Muss dem Lehrer gemeldet werden.",
    isStrictlyProhibited: "Ist strengstens untersagt.",
    sampleQuestionsFromAnIHKExpertKnowledgeExamination: "Beispielfragen aus einer IHK Expertenwissenprüfung §34a gemäß GewO",
    verify: "Prüfen",
    searchPlaceholder: "Hier suchen...",
    next: "Nächste Frage",
    previous: "Vorherige Frage",
    current: "Aktuell",
    checked: "Beanwortet",
    correct: "Korrekt",
    wrong: "Falsch",
    review: "Uberprufung",

    subjectKnowledge34aSimulation: "Sachkunde 34a – Prüfungssimulation",
    expertiseSection34aExercisesForTheOralExamination: "Sachkunde §34a – Übungen für die mündliche Prüfung",
    examMode: "Prüfungsmodus",
    practiceMode: "Übungsmodus (Learnmode)",
    subjectKnowledge34aPractice: "Sachkunde 34a – Übungen für die schriftliche Prüfung",

    passed: "Bestanden",
    failed: "Nicht bestanden",
  },
  auth: {
    login: "Anmelden",
    logout: "Abmelden",
    username: "E-Mail/Benutzer ID",
    password: "Passwort",
    rememberMe: "Angemeldet bleiben",
    forgotPassword: "Passwort vergessen?",
    welcomeMessage: "Geben Sie Ihre Anmeldedaten ein und genießen Sie unsere Kurse",
    usernamePlaceholder: "Geben Sie Ihre Benutzer ID ein",
    passwordPlaceholder: "Geben Sie Ihr Password ein",
    welcomeMessage1: "Willkommen zurück.",
    welcomeMessage2: "Melde dich",
    welcomeMessage3: "jetzt an!"
  },
  sidebar: {
    main: "HAUPTSEITE",
    others: "ANDERE",
    dashboard: "Dashboard",
    users: "Benutzer",
    participants: "Teilnehmer",
    documents: "Dokumente",
    attendance: "Teilnahme",
    settings: "Einstellungen",
    carrier: "Träger",
    notifications: "Benachrichtigungen",
    logout: "Abmelden",
    examHistory: "Prüfungsverlauf",
    ihreTragerzertifikate: "Ihre Trägerzertifikate",
    liveWebinare: "Live-Webinare",
    schriftlichePrufung: "Über 800 Fragen (Schriftlich)",
    mundlichePrufung: "Über 800 Karteikarten (Mündlich)",
    feedbackbogen: "Feedbackbogen",
    students: "Studenten",
    measurement: "Messung",
    intermediary: "Vermittler (Internal)",
    examinations: "Prüfungen",
    bridgeDays: "Brückentage",
    lecturers: "Dozenten",
    qualificationPlan: "Qualifizierungsplan"
  },
  header: {
    welcome: "Willkommen zurück",
    search: "Hier suchen",
    language: "Sprache",
    english: "Englisch",
    german: "Deutsch"
  },
  users: {
    title: "Benutzer",
    list: "Benutzerliste",
    add: "Neuen Benutzer hinzufügen",
    edit: "Benutzer bearbeiten",
    delete: "Benutzer löschen",
    confirmDelete: "Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?",
    cancel: "Abbrechen",
    save: "Speichern",
    search: "Benutzer suchen",
    table: {
      id: "ID",
      name: "Name",
      email: "E-Mail",
      address: "Anschrift",
      status: "Status",
      action: "Aktion",
      userName: "Benutzername",
      firstName: "Vorname",
      lastName: "Nachname",
      phoneNumber: "Telefonnummer",
      dateOfBirth: "Geburtsdatum",
      zipCode: "Postleitzahl",
      placeOfBirth: "Geburtsort",
      countryOfbirth: "Geburtsland",
      telephone: "Telefon",
      city: "Stadt"
    },
    form: {
      userName: "Benutzername",
      firstName: "Vorname",
      lastName: "Nachname",
      phoneNumber: "Telefonnummer",
      email: "E-Mail",
      address: "Anschrift",
      status: "Status",
      password: "Password",
      confirmPassword: "Passwort bestätigen"
    },
    validation: {
      required: "Dieses Feld ist erforderlich",
      email: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      password: "Das Password muss mindestens 8 Zeichen lang sein",
      confirmPassword: "Passwörter stimmen nicht überein"
    }
  },
  searchFilter: {
    search: "Suchfilter"
  },
  home: {
    cards: {
      totalStudents: "Gesamtzahl der Studenten",
      totalTeachers: "Gesamtzahl der Lehrer",
      totalEmployee: "Gesamtzahl der Mitarbeiter",
      totalCourses: "Gesamtzahl der Kurse"
    },
    charts: {
      attendance: "Teilnahme Diagramm",
      totalStudents: "Gesamtzahl der Studenten",
      byGender: "nach Geschlecht",
      boys: "Jungen",
      girls: "Mädchen",
      thisWeek: "Diese Woche",
      lastWeek: "Letzte Woche",
      thisMonth: "Diesen Monat",
      present: "Gesamtzahl der Anwesenden",
      absent: "Gesamtzahl der Abwesenden"
    }
  },
  students: {
    studentsList: "Teilnehmer Liste",
    add: "Neuen Teilnehmer hinzufügen",
    edit: "Teilnehmer bearbeiten",
    delete: "Teilnehmer löschen",
    confirmDelete: "Sind Sie sicher, dass Sie diesen Teilnehmer löschen möchten?",
    cancel: "Abbrechen",
    save: "Speichern",
    participantData: "Teilnehmerdaten"
  },
  measurement: {
    addNewMeasurement: "Neue Maßnahme erstellen",
    measurementList: "Maßnahmen Liste",
    measurements: "Maßnahme",
    no: "Nr.",
    measuresNumber: "Maßnahmen Nummer",
    measuresTitle: "Maßnahmen Titel",
    months: "Monate",
    showInDocuments: "In Unterlagen anzeigen",
    edit: "Bearbeiten",
    accordingToParagraph: "Nach Paragraph",
    measureEdit: "Maßnahmen bearbeiten",
    createNewMeasurement: "Neue Maßnahme erstellen",
    measure: "Maßnahmen",
    registeredForTheMeasureAre: "Zur Maßnahme angemeldet sind"
  },
  intermediary: {
    insertNewAgent: "Neuen Vermittler einfügen",
    intermediary: "Vermittler",
    addNewIntermediary: "Neuen Vermittler einfügen",
    agentEmail: "Vermittler email",
    agentTel: "Vermittler Tel",
    eMustermannMustermann: "(z.B: Max Mustermann oder Herr Musterman)",
    intermediaryParticipant: "Vermittelte Teilnehmer",
    agentsBearbetten: "Vermittler Bearbeiten"
  },
  examinations: {
    examinations: "Prüfungen",
    insertNewTest: "Neue Prüfung einfügen",
    test: "Prüfung",
    addNewTest: "Neue Prüfung einfügen",
    examinationTitle: "Prüfungsbezeichnung"
  },
  bridgeDays: {
    bridgeDays: "Brückentag",
    addNewBridgeDay: "Brückentag einfügen",
    bridgeDayList: "Brückentag Liste",
    bridgeDay: "Brückentag",
    insertBridgeDays: "Brückentag erstellen"
  },
  documents: {
    assessmentOfSuitability: "Zur Eignungsbewertung",
    dataCollectionForm: "Erfassungsbogen",
    generateLink: "Link generieren",
    generatedLink: "Generierter Link",
    createNewUrlForSuitabilityAssessment: "Neue URL für Eignungsbewertung erstellen",
    createNewUrlForDataEntryForm: "Neue URL für Datensammlungsformular erstellen",
    YouCanEditTheRegistrationFormAtAnyTime: "Sie können die Registrierungsformular jederzeit bearbeiten.",
    clickGenerateLink: 'Klicken Sie auf den "Link generieren"-Button, um eine benutzerdefinierte URL zu generieren, die Sie an Ihren Kunden senden können.',
    clickCopy: 'Klicken Sie auf den "Link kopieren"-Button, um die URL in Ihre Zwischenablage zu speichern.',
    youCanNowSendTheLink: 'Sie können jetzt die Link an Ihren Kunden in jeder Art senden, via WhatsApp oder E-Mail.',
    linkIsValidFor8Days: "Die URL ist für 8 Tage gültig. Wenn Ihr Kunde die Eignungsbewertung innerhalb von 8 Tagen nicht abschließt, wird diese URL aus dem System gelöscht.",
    youCanGenerateAsManyLinksAsYouLike: "Sie können so viele Links wie Sie möchten generieren.",
    createdUrls: "Erzeugte URLs",
    linkDate: "Linkdatum",
    measuresTitle: "Maßnahmenüberschriften",
    firstName: "Vorname",
    lastName: "Nachname",
    dateSignature: "Datum, Unterschrift",
    comment: "Kommentar",
    aptitudeAssessmentFrom: "Eignungsbewertung von",
    commentsNotes: "Bemerkungen",
    updateAndRegeneratePdf: "Aktualisieren und erneut generieren",
    notYetSigned: "Noch nicht unterschrieben! Diese URL wird automatisch in 6 Tagen gelöscht.",
    copy: "Kopieren",
    dataCollectionForm: "Erfassungsbogen",
    whichMeasureIsTheParticipantInterestedIn: "Welche Maßnahme interessiert den Teilnehmer?",
    specialKnowledge: "Besondere Kenntnisse",
    languages: "Sprachen",
    wordAndWriting: "Wort und Schrift",
    personalSuitability: "Persönliche Eignung",
    professionalSuitability: "Fachliche Eignung",
    professionalInformation: "Berufliche Informationen",
    assessmentOfConsultation: "Bewertung der Beratung (Maßnahmeziel erreicht)",
    notesRecommendations: "Bemerkungen/empfohlene Maßnahmen Bildungsakademie Deutschland GmbH:"
  },
  lecturers: {
    lecturersList: "Dozentenliste",
    addNewLecturer: "Neuen Dozenten hinzufügen",
    lecturer: "Dozent",
    measure: "Maßnahme",
    certificates: "Qualifikationsnachweise / Zertifikate"
  },
  onlineCourses: {
    logout: "Ausloggen",
    onlineCourses: "Onlinekurse",
    loggedIn: "Sie sind eingeloggt",
    carrierCertificates: "Trägerzertifikate",
    carrierCertificatesDescription: "Angaben für Ihre zukünftig bei uns erworbenen Zertifikate:",
    certificateInstructions: "Bitte füllen Sie die Felder aus, falls sie leer sind, oder berichtigen Sie die Angaben, falls sie fehlerhaft sind. Diese Informationen werden auf Ihrem Zertifikat angezeigt.",
    dateOfBirth: "Geburtsdatum",
    placeOfBirth: "Geburtsort",
    update: "aktualisieren",
    yourCarrierCertificates: "Ihre Trägerzertifikate",
    noCarrierCertificates: "Sie haben noch keine Trägerzertifikate erworben!",
    carrierCertificateCreationNotice: "Bitte beachten Sie, dass es 5 - 10 Minuten dauern kann, bis das Trägerzertifikat nach erfolgreichem Abschluss der Lektion erstellt ist.",
    additionalQualifications: "Zusatzqualifizierungen",
    previousLesson: "Vorherige Lektion",
    nextLesson: "Nächste Lektion",
    inProgress: "In Bearbeitung",
    videoLessonsInGermanNB: "Videolektionen in deutscher Sprache NB",
    liveWebinars: "Live-Webinare",
    exercisesForTheWrittenExamination: "Übungen für die schriftliche Prüfung",
    Over1000QuestionsForWrittenExamination: "Uber 1.000 Fragen fur schriftliche Prufung",
    joinRoom: "Raum 12 Betreten",
  },
  home_filter_option: {
    select_all: "Select all",
    zusatzqualifizierungen: "Zusatzqualifizierungen",
    live_webinare: "Live-Webinare",
    uber_1000_fragen_schriftliche_prufung: "Über 1.000 Fragen für schriftliche Prüfung",
    uber_800_fragen_schriftliche_prufung: "Über 800 Fragen für die schriftliche Prüfung",
    lernvideos_ihk_geprufte_sicherheitsfachkraft_34a_gewo: "Lernvideos: IHK geprüfte Sicherheitsfachkraft gem. 34a GewO",
    uber_900_karteikarten_mundliche_prufung: "Über 800 Karteikarten für die mündliche Prüfung",
    neueste_situationsbedingte_fragen_mundliche_prufung: "Neueste situationsbedingte Fragen für die mündliche Prüfung",
    forderung_beruflichen_weiterbildung_ergebnisbogen_bewerberprofil: "Förderung der beruflichen Weiterbildung Ergebnisbogen / Bewerberprofil",
    feedbackbogen_teilnehmerinnen_teilnehmer_beruflichen_weiterbildungmabnahmen: "Feedbackbogen für Teilnehmerinnen und Teilnehmer an beruflichen Weiterbildungsmaßnahmen",
    continue_to_online_course: "Weiter zum Onlinekurs",
    continue_to_exercises: "Weiter zu den Übungsaufgaben",
    commingSoon: "Bald verfügbar",
    continue_to_live_webinar: "Zum Unterricht",
    fill_in_the_results_form: "Ergebnissbogen ausfüllen"
  },
  resultsSheet: {
    applicationForProfessionalDevelopmentFundingResultsSheet: "Förderung der berufliuchen Weiterbildung Ergebnisbogen / Bewerberprofil",
    participant: "Teilnehmer/in",
    skillsKnowledgeAbilities: "Fertigkeiten, Kenntnisse und Fahigkeiten (primar im Rahmen der Maßnahme erworben)",
    skillsKnowledgeAbilitiesNote: "Nutzen Sie hierzu auch die im Internet unter: ",
    skillsKnowledgeAbilitiesNoteText: "BERUFENET - “Berufsbezeichnung” - Tätigkeit - Kompetenzen hinterlegten Berufsbeschreibungen. Bitte ergänzen Sie diese Liste bei Bedarf auf einer anderen Seite! Die Angaben dienen auch zur Überarbeitung des Bewerberprofils in der Jobbörse. ",
    YouCanAlsoMakeTheRevisionDirectlyInTheJobPortal: "Sie konnen die Überarbeitung auch direkt in der Jobbörse vornehmen!",
    YouCanAlsoMakeTheRevisionDirectlyInTheJobPortalNote: "Dazu benötigen Sie Ihre Zugangsdaten und schreibenden Zugriff auf Ihre Fahigkeiten, Sollten Sie nicht darüber verfügen, sprechen Sie Ihren Betreuer darauf an.",
    skillsKnowledgeAbilitiesAttention: "Fertigkeiten, Kenntnisse und Fahigkeiten Achtung!!!",
    skillsKnowledgeAbilitiesAttentionNote: "Eintrage fur Sachkunde, Ersthelder und Waffensachkunde werden automatisch eingetrtagen sobald die jeweilige “Prufung” unter Teilnehmerdaten erstelt wird!",
    itSkills: "IT Kenntnisse",
    itSkillsNote: "(z.B. Office-, Grafikprogramme, Branchensoftware, Programmierung)",
    languageSkills: "Sprachkenntnisse",
    mobility: "Mobilitat",
    mobilityNote: "(nach Ende der Maßnahme)",
    internship: "Praktikum",
    internshipNote: "(nur ausfullen bei Maßnahmen mit Praktikum)",
    mobilityReadiness: "Mobilitatsbereitschaft",
    internshipDuringMeasure: "Praktikum während der Maßnahme",
    employmentBehavior: "Bewerbungsverhalten",
    jobApplicationActivitiesDuringTheMeasure: "Bewerbungsaktivitäten während der Maßnahme",
    possiblyAttachmentInListForm: "(ggf. Anhang in Listenform)",
    futureJobApplicationActivities: "Zukünftige Bewerbungsaktivitäten erstrecken sich auf folgende Berufe / Tätigkeiten",
    futureJobApplicationActivitiesNote: "(Mit Ihren Zugangsdaten fur die Jobbörse konnen Sie diese auch direkt in ein neues Stellengesuch eintragen!)",
    alternativesIndustryTemporary: "Alternativen (z.B. Branche, Zeitarbeit, Selbstständigkeit)",
    otherNotes: "Sonstige Anmerkungen",
    otherNotesNote: "(z. B. Erganzungen und weitere Informationen, die im Rahmen der Maßnahme-durchfuhrung erhoben wurden, z. b.Aktualitat/Anerkennung von Zertifizierungen)",
    participantSignature: "Unterschrift Teilnehmer"
  },
  vocationalTraining: {
    questionnaireForParticipantsInVocationalTrainingPrograms: "Fragebogen für Teilnehmerinnen und Teilnehmer an beruflichen Weiterbildungsmaßnahmen",
    vocationalTraining: "Sie nehmen derzeit an einer beruflichen Weiterbildungsmaßnahme teil. Für die Bundesagentur für Arbeit ist es wichtig zu wissen, welche Erfahrungen Sie mit dieser Maßnahme gemacht haben. Ihre Aussagen können weiterhelfen, die Qualität der beruflichen Weiterbildung zu verbessern.",
    youWillBeAskedToEvaluateTheTrainingProgram: "Im Folgenden werden Sie um eine Beurteilung der von Ihnen besuchten Weiterbildungsmaßnahme gebeten.",
    privacy: "Ihre Angaben werden selbstverständlich anonym (ohne Namen) ausgewertet;",
    privacyNote: "Rückschlüsse auf Ihre Person sind nicht möglich, so dass Ihnen auch keine Nachteile aufgrund Ihrer Angaben entstehen.",
    note: "Wenn Sie auf den Smiley oder die Antwortoption klicken, wird Ihre Antwort sofort gespeichert und erscheint nicht mehr in der Liste!",
    programTitle: "Bezeichnung der Weiterbildungsmaßnahme",
    providerTitle: "Bildungsträger/-einrichtung",
    numberTitle: "Maßnahme-Nummer",
    status: "Es sind noch 21 von 21 Fragen zu beantworten!",
    q1: "Die vorhandenen Räumlichkeiten (Unterrichts- und Arbeitsräume, Werkstätten, Pausenräume, sanitäre Anlagen) sind in ordnungsgemäßem Zustand.",
    q2: "Eine ausreichende technische Ausstattung (PC, Maschinen, Werkzeuge) ist vorhanden.) sind in ordnungsgemäßem Zustand.",
    q3: "Lehr- und Lernmittel (z.B. Arbeitskleidung, Bücher, Skripte, Arbeitsblätter) stehen zur Verfügung.",
    q4: "Die Ausbilder/innen und Lehrkräfte vermitteln die Lehrgangsinhalte verständlich",
    q5: "Die Ausbilder/innen und Lehrkräfte gehen im Unterricht auf die Teilnehmer/innen ein und unterstützen sie",
    q6: "Die Ausbilder/innen und Lehrkräfte geben Rückmeldungen zum jeweiligen Leistungsstand.",
    q7: "Mitarbeiter/innen der Bildungseinrichtung unterstützen die Teilnehmer/innen bei persönlichen Schwierigkeiten.",
    q8: "Mitarbeiter/innen der Bildungseinrichtung unterstützen die Teilnehmer/innen bei der Suche nach einem geeigneten Arbeitsplatz.",
    q9: "Vor Lehrgangsbeginn erfolgte eine ausreichende Information über Inhalte und (zeitlichen) Ablauf.",
    q10: "Die Bildungseinrichtung hat mit mir einen Schulungsvertrag abgeschlossen, der wesentliche Angaben zur Qualifizierung enthält (z.B. Qualifizierungsinhalte, Praktikazeiten, Angaben zu Lernmitteln und Arbeitskleidung, Rücktritts- und Kündigungsmodalitäten).",
    q11: "Die Teilnehmer des Lehrgangs passen hinsichtlich ihrer Berufsausbildung bzw. ihren Vorkenntnissen gut zusammen.",
    q12: "Die Lehrgangsinhalte / der vermittelte Lehrstoff entsprechen meinen Vorkennt-nissen und Erwartungen.",
    q13: "Die Lehrstoff wird verständlich vermittelt.",
    q14: "Der Unterricht ist so ausgestaltet, dass mir gentigend Zeit bleibt, das Erlernte zu verarbeiten und zu verfestigen.",
    q15: "Der Lehrgang ist gut organisiert (z.B. hinsichtlich rechtzeitiger und umfassender ereitstellung von Stundenplänen, Pausenregelungen, Ubungs-möglichkeiten).",
    q16: "Im Lehrgang werden unterschiedliche Medien eingesetzt (z.B. Flip-Chart, Unterrichtsfolien, Beamer, Filme, interaktive Medien).",
    q17: "Es gibt regelmäßig Lernerfolgskontrollen (z.B. Klassenarbeiten, Tests, praktische Aufgaben).",
    q18: "Bei Ausfall von Lehrkräften / Ausbilder/innen ist eine Vertretung sichergestellt.",
    q19: "Welche der genannten Aussagen trifit bei der Beurteilung der Qualifizierungs-maßnahmen Ihrer Meinung nach am ehesten zu?",
    q20: "Die Dauer der Qualifizierungsmaßnahme ist nach meiner jetzigen Einschätzung für mich insgesamt ..",
    q21: "Insgesamt bin ich mit der Qualfizierungsmaßnahme zufrieden oder nicht zufrieden?",
    satisfied: "Zufrieden",
    notSatisfied: "Nicht zufrieden",
    neutral: "Neutral",
    questions: "Fragen",
    justRight: "gerade richtig",
    tooShort: "zu kurz",
    partial: "zum Teil",
    tooLong: "zu lang",
    canSayYet: "kann ich noch nicht sagen",
    helpful: "Die Qualifizierung hilft mir, leichter einen Arbeitsplatz zu finden",
    unchanged: "Meine Chancen auf einen Arbeitsplatz haben sich nicht verändert",
    worse: "Ich habe nur Zeit verloren, meine Chancen auf einen Arbeitsplatz sind schlechter geworden",
    unknown: "Ich kann jetzt noch nicht sagen, ob sich etwas verändert",
    noteAndRemark: "Hinweise und Anmerkungen",
    noteAndRemarkNote: "Wenn Sie zur besuchten Qualifizierungsmaßnahme noch weitere Hinweise und Anmerkungen haben, können Sie diese nachfolgend schildern:"
  },
  liveWebinar: {
    liveWebinar: "Live - Unterricht mit unseren Dozenten",
    liveWebinarNote: "Täglich von Montag bis Freitag ab 09:00 bis 16:15 Uhr",
    courseHomepage: "Startseite der Maßnahme",
    lecturer: "Dozent",
    joinRoom: "Zoom Raum Betreten",
    room: "Unterrichts Zoom Raum"
  },
  table: {
    previous: "Vorherige",
    next: "Nächste",
  },
  learningProgress: {
    learningProgress: "Lernfortschritt",
    subjectKnowledge32a: "Sachkunde 34a - Videolektionen in deutscher Sprache",
    courseStarted: "Kurs angefangen am",
    lastVisit: "Letzter Besuch",
    certificate: "Zertifikat",
    title: "Titel",
    error: "Fehler",
    points: "Punkte",
    firstAidPreparation: "Ersthelfer Vorbereitung (BB)",
    firePrevention: "Bransschutz & Evakuierungshelfer gemaB10ArbSchG (BB)",
    examinationsAndTests: "Prufungen und Tests",
    firearmsPreparation: "Waffensachkundevorbereitung gem. 7 WaffG  (BB)",
    subjectKnowledge34a: "Sachkunde34a - Ubungen fur die schriftliche Prufung",
    subjectKnowledge34aTest: "Sachkunde 34a - Probeprufungen"
  },
  form: form
};